import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class GlobalEmailService {


user;
username;

constructor(public auth: AuthService, public http:HttpClient) {

  this.auth.userProfile$.subscribe(
    (profile) => {

      this.user = profile;
      this.username = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

 }




  private baseURL = environment.baseUrl;


  sendDebugEmail(urgency: any, form: any, section: any, error: any): Observable<any> {

    let obj = {
      urgency : urgency,
      form : form,
      section : section,
      error : error
    };

    return this.http.post(this.baseURL + '/rhAPI/emails/sendDebugEmail', obj, {observe: 'body'});

  }

  sendSupportEmail(notes:string, location:string): Observable<any>{
    console.log(notes);

    let obj = {
      notes : notes,
      location : location
    }

    return this.http.post(this.baseURL + '/rhAPI/emails/rfSupportEmail', obj, {observe: 'body'});

  }


}
